import { Field, ID, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { FsaContact } from './FsaContact'

@ObjectType()
export class Fsa {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  county?: string

  // The state of the county; legacy labelled a county by "county - state", and a county name alone is not unique.
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  state?: string

  @Field(() => [FsaContact], { nullable: true })
  @Prop({ type: [FsaContact] }, PropType.ARRAY)
  contacts?: ReturnType<() => FsaContact[]>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string
}
